import React from 'react';

const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * チャット検索の本文ヒット行で、一致キーワードを背景ハイライト（<mark>）で示す。
 * ラベルは付けず色だけで意味を伝える方針（表示量を削らない）。
 *
 * @param {string} text  表示するプレビュー本文
 * @param {string} query 一致キーワード（本文検索語）
 * @returns ハイライト済みのReactノード
 */
export const renderChatSearchHighlight = (text, query) => {
  const source = String(text || '');
  const needle = String(query || '').trim();
  if (!source) return null;
  if (!needle) return source;
  try {
    const parts = source.split(new RegExp(`(${escapeRegExp(needle)})`, 'ig'));
    return parts.map((part, index) =>
      index % 2 === 1 ? (
        <mark key={index} className="event-list__hit-mark">{part}</mark>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      )
    );
  } catch {
    return source;
  }
};

export default renderChatSearchHighlight;
